// The two pages the browser lands on at the end of an authorization. They are the last thing the user sees
// before switching back to the terminal, so they say which window to close and nothing else.

const PAGE_STYLES = `
  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }
  body { font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; font-size: 14px; background: #F3F4F6; color: #111827; display: flex; justify-content: center; align-items: center; min-height: 100vh; padding: 16px; }
  .card { background: #fff; border-radius: 16px; box-shadow: 0 0.125rem 0.25rem rgba(0,0,0,0.075); width: 100%; max-width: 420px; padding: 32px; text-align: center; }
  .brand { font-size: 20px; font-weight: 700; color: #7f7fed; margin-bottom: 24px; }
  .icon { width: 48px; height: 48px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 16px; font-size: 24px; }
  .icon-success { background: rgba(16,185,129,0.1); color: #10B981; }
  .icon-error { background: rgba(220,38,38,0.1); color: #DC2626; }
  h1 { font-size: 20px; font-weight: 600; margin-bottom: 8px; }
  p { font-size: 14px; color: #6B7280; line-height: 1.5; }
  p + p { margin-top: 4px; }
`

export const SUCCESS_HTML = `<!DOCTYPE html>
<html><head><meta charset="UTF-8"><title>Authorized — FlowRunner CLI</title>
<style>${PAGE_STYLES}</style>
</head><body>
<div class="card">
  <div class="brand">FlowRunner</div>
  <div class="icon icon-success">&#10003;</div>
  <h1>Authorization Successful</h1>
  <p>You can close this window and return to the terminal.</p>
</div>
</body></html>`

export const ERROR_HTML = (error: string) => `<!DOCTYPE html>
<html><head><meta charset="UTF-8"><title>Authorization Failed — FlowRunner CLI</title>
<style>${PAGE_STYLES}</style>
</head><body>
<div class="card">
  <div class="brand">FlowRunner</div>
  <div class="icon icon-error">&#10007;</div>
  <h1>Authorization Failed</h1>
  <p>${error}</p>
  <p>You can close this window and try again.</p>
</div>
</body></html>`
